import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@24.1.0_@upstash+redis@1.35.0_@vue+compile_7fce59830cf89b2ec31e1e9286565a79/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}